/**
 * MODAIRA Global Animations Engine
 * Handles Fade-in on Scroll and Smooth Page Transitions.
 * Strictly respects merchant toggles, dynamic speed slider, and OS prefers-reduced-motion.
 */

(function() {
  function getIsReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getPageTransitionDuration() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--page-transition-duration').trim();
    var duration = parseInt(raw, 10);
    return isNaN(duration) ? 300 : duration;
  }

  // ==========================================
  // 1. Fade-in on Scroll (IntersectionObserver)
  // ==========================================
  function initScrollAnimations() {
    var isReducedMotion = getIsReducedMotion();
    var isAnimationsDisabled = document.body.classList.contains('animations-disabled');
    var isScrollFadeDisabled = document.body.classList.contains('scroll-fade-disabled');

    var animatedElements = document.querySelectorAll('[data-animate-on-scroll]');
    if (!animatedElements.length) return;

    if (!isReducedMotion && !isAnimationsDisabled && !isScrollFadeDisabled && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries, obs) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            obs.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '0px 0px -40px 0px',
        threshold: 0.1
      });

      animatedElements.forEach(function(el) {
        observer.observe(el);
      });
    } else {
      animatedElements.forEach(function(el) {
        el.classList.add('is-in-view');
      });
    }
  }

  // ==========================================
  // 2. Smooth Page Fade Transitions
  // ==========================================
  function initPageTransitions() {
    document.addEventListener('click', function(e) {
      var isReducedMotion = getIsReducedMotion();
      var isAnimationsDisabled = document.body.classList.contains('animations-disabled');
      var isPageTransitionsDisabled = document.body.classList.contains('page-transitions-disabled');

      if (isReducedMotion || isAnimationsDisabled || isPageTransitionsDisabled) return;

      var link = e.target.closest('a');
      if (!link) return;

      // Ignore non-standard mouse clicks / modifier keys
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      var href = link.getAttribute('href');
      if (!href) return;

      // Skip hashes, protocols, downloads, target="_blank"
      if (href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;
      if (link.getAttribute('target') === '_blank' || link.hasAttribute('download')) return;

      // Skip in-page UI triggers (Cart drawer, modal, swatches, accordions)
      if (link.hasAttribute('data-cart-drawer-trigger') || link.hasAttribute('data-no-transition') || link.classList.contains('js-card-swatch')) return;

      var currentUrl = new URL(window.location.href);
      var targetUrl;
      try {
        targetUrl = new URL(link.href, window.location.origin);
      } catch (err) {
        return;
      }

      // Same-origin only
      if (targetUrl.origin !== currentUrl.origin) return;

      // Same page anchor navigation (e.g. /#MainContent)
      if (targetUrl.pathname === currentUrl.pathname && targetUrl.search === currentUrl.search && targetUrl.hash) return;

      var durationMs = getPageTransitionDuration();
      if (durationMs <= 10) return;

      // Prevent abrupt instant jump, trigger smooth fade-out, then navigate
      e.preventDefault();
      document.body.classList.add('modaira-page-transitioning');

      setTimeout(function() {
        window.location.href = targetUrl.href;
      }, durationMs);
    });

    // Handle bfcache (Browser Back / Forward Button)
    window.addEventListener('pageshow', function(event) {
      document.body.classList.remove('modaira-page-transitioning');
    });
  }

  // Initialize once DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initScrollAnimations();
      initPageTransitions();
    });
  } else {
    initScrollAnimations();
    initPageTransitions();
  }
})();
